import { submit, invalid, buttonClick } from "../clientSideValidation";

const initializeClientSideValidations = () => {
    submit();
    invalid();
    buttonClick();
};

export default initializeClientSideValidations;
